export default function localizeValue(value, lang = null) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  let locale = lang || localStorage.getItem('i18nextLng');
  if (locale !== 'ar') locale = 'en';
  // Handle object with language-specific arrays
  if (typeof value === 'object') {
    if (Array.isArray(value[locale])) {
      return value[locale][0] || '';
    }
    // For objects with a 'value' key
    if ('value' in value) {
      return value[locale === 'ar' ? 'value' : 'alt'];
    }
    // Handle other object structures
    return value[locale] || '';
  }
  return value[locale];
}
